<template>
  <div>
    <v-dialog v-model="showModalResetPassword" max-width="560">
      <v-card class="pa-6 rounded-xl">

        <!-- CLOSE -->
        <div class="d-flex justify-end">
          <v-btn
              icon
              variant="text"
              @click="setState(false)"
          >
            <i class="fa-solid fa-xmark"></i>
          </v-btn>
        </div>

        <!-- HEADER -->
        <div class="mb-6">
          <h2 class="text-h5 font-weight-bold mb-2">
            Passwort zurücksetzen
          </h2>

          <p class="text-medium-emphasis">
            <span v-if="!jwt">
              Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen.
            </span>
            <span v-else>
              Lege jetzt ein neues sicheres Passwort fest.
            </span>
          </p>
        </div>

        <!-- ERROR -->
        <v-alert
            v-if="errorResetPassword"
            class="mb-4"
            density="comfortable"
            type="error"
            variant="tonal"
        >
          {{ errorResetPassword }}
        </v-alert>

        <!-- FORM -->
        <v-form
            v-model="valid"
            lazy-validation
            @submit.prevent.stop="resetPassword"
            :disabled="loadingResetPassword"
        >

          <!-- EMAIL STEP -->
          <v-text-field
              v-if="!jwt"
              v-model="email"
              :rules="[rules.required, rules.email]"
              label="E-Mail Adresse"
              type="email"
              variant="outlined"
              density="comfortable"
              clearable
          />

          <!-- PASSWORD STEP -->
          <template v-else>
            <v-text-field
                v-model="newPassword"
                :rules="[rules.required, rules.password, rules.passwordMin, rules.passwordMax]"
                label="Neues Passwort"
                type="password"
                variant="outlined"
                density="comfortable"
                class="mb-3"
                clearable
            />

            <v-text-field
                v-model="confirmNewPassword"
                :rules="[rules.required, rules.confirm]"
                label="Passwort bestätigen"
                type="password"
                variant="outlined"
                density="comfortable"
                clearable
            />
          </template>

          <!-- ACTION -->
          <div class="d-flex justify-end mt-6">

            <v-btn
                :disabled="loadingResetPassword"
                :loading="loadingResetPassword"
                color="primary"
                size="large"
                type="submit"
                class="px-6"
                style="text-transform: none !important;"
            >
              {{ jwt ? 'Passwort speichern' : 'Link senden' }}
            </v-btn>

          </div>

        </v-form>

      </v-card>
    </v-dialog>

    <Toast ref="Toast"/>
  </div>
</template>

<script>
import Toast from '@/components/modal/Toast.vue';
import {mapGetters} from "vuex";

export default {
  name: 'ModalResetPassword',
  components: {
    Toast
  },
  data() {
    return {
      showModalResetPassword: false,
      valid: false,
      email: '',
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      rules: {
        required: value => !!value || 'Pflichtfeld.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Die E-Mail ist ungültig.'
        },
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Za-z])(?=.*[0-9])(?=.*[~!@#$%^&*\-_+=|";[\]{}()<>,./?\\])/;
          return pattern.test(value) || 'Das Passwort muss Buchstaben, Ziffern und Sonderzeichen(~!@#$%^&*-_+=|";[]{}()<>,./?\\) enthalten.';
        },
        passwordMin: value => value.length >= 9 || 'Das Passwort muss mindestens 9 Zeichen lang sein.',
        passwordMax: value => value.length <= 20 || 'Das Passwort darf maximal 20 Zeichen lang sein.',
        confirm: value => (value === this.newPassword) && this.newPassword !== '' || 'Die Passwörter müssen übereinstimmen.'
      },
      jwt: this.$route.query.resetPasswordToken || null
    }
  },
  computed: {
    ...mapGetters([
      'loadingResetPassword',
      'errorResetPassword'
    ])
  },
  methods: {
    setState(state) {
      this.showModalResetPassword = state;
    },
    resetPassword() {
      if (this.valid) {
        if (!this.jwt) {
          this.$store.dispatch('requestResetPassword', {
            email: this.email
          })
              .then(response => {
                if (response) {
                  this.$refs.Toast.show({
                    color: 'success',
                    icon: 'fa-solid fa-check',
                    title: 'E-Mail wurde gesendet',
                    text: 'Bitte überprüfen sie Ihre E-Mails. Schauen Sie auch in Ihren Spam Ordner.'
                  });
                }
              });
        } else {
          this.$store.dispatch('submitResetPassword', {
            jwt: this.jwt,
            newPassword: this.newPassword
          }).then(response => {
            if (response) {
              this.$refs.Toast.show({
                color: 'success',
                icon: 'fa-solid fa-check',
                title: 'Passwort erfolgreich zurückgesetzt',
                text: 'Sie können sich nun normal anmelden.'
              });
            }
          });
        }
      }
    }
  }
}
</script>